export default __webpack_public_path__ + "static/media/Clarity.85117d6f.svg";